export function getForeignPersonalInfo(foreignPersonalInfoRepository) {
  return foreignPersonalInfoRepository.get();
}